import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';

@Component({
  selector: 'app-cinejoy-footer',
  templateUrl: './cinejoy-footer.component.html',
  styleUrls: ['./cinejoy-footer.component.css']
})
export class CinejoyFooterComponent implements OnInit {

  copyright:any
  footerList:any;
  header:any;
  constructor(private service:AdminService) { }

  ngOnInit(): void {
    this.service.getCopyright().subscribe(data=>{
      this.copyright = data.copyRightText
    })

    this.service.getAllFooterSections().subscribe((res:any)=>{
      this.footerList = res.filter((v:any)=> v.section !== 'Header');
      this.header = res.find((v:any)=> v.section == 'Header')
    }, err=>{
      console.log(err)
    })
  }

}
